export class RcsMessageDto {
    messageId: number;
    folderId: number;
    isDeleted: boolean;
    messageName: string;
    rcsType: string;
    rcsContentJson: string;
    smsFallbackEnabled: boolean;
    smsFallbackText: string;
    smsFallbackClientInboxId: number;
    suggestions: any[];

    constructor(init: any) {
        this.messageId = init.MessageID;
        this.folderId = init.FolderID;
        this.isDeleted = init.IsDeleted;
        this.messageName = init.MessageName;
        this.rcsType = init.RCSType;
        this.rcsContentJson = init.RCSContentJson || init.rcsContentJson || '';
        this.smsFallbackEnabled = init.SMSFallbackEnabled;
        this.smsFallbackText = init.SMSFallbackText || '';
        this.smsFallbackClientInboxId = init.SMSFallbackClientInboxID ? parseInt(init.SMSFallbackClientInboxID, 10) : 0;
        this.suggestions = init.Suggestions || init.suggestions || [];
    }
}